import React from 'react';

/**
 * Shared PG/wire method selector. Extracted so PackCheckoutStep.jsx (packs —
 * PG methods only) doesn't duplicate the block ManageMembershipPage.jsx's
 * STEP_DETAILS already has for plans (PG methods + 무통장 입금).
 *
 * §10.2-A2 / A3 — the labels for 계좌이체 and 무통장 입금 are DISTINCT on
 * purpose: both would read as "bank transfer" in English if collapsed to one
 * label, but one settles instantly through PortOne and the other is a manual,
 * admin-confirmed deposit. `showWire` is false for packs: there is no
 * admin-confirmed path for a credit pack, only POST /payments/checkout/pack
 * going through PortOne, so rendering that option would be a dead control.
 */
export default function PaymentMethodOptions({ isKo, payMethod, setPayMethod, showWire = true }) {
  return (
    <div className="mmpage-paymethod">
      <div className="mmpage-paymethod-title">
        {isKo ? '결제 수단을 선택하세요' : 'How would you like to pay?'}
      </div>
      <div className="mmpage-paymethod-options">
        <button type="button"
          className={`mmpage-paymethod-opt ${payMethod === 'card' ? 'is-active' : ''}`}
          onClick={() => setPayMethod('card')}>
          💳 {isKo ? '신용카드' : 'Credit Card'} <span>{isKo ? '즉시' : 'instant'}</span>
        </button>
        <button type="button"
          className={`mmpage-paymethod-opt ${payMethod === 'transfer' ? 'is-active' : ''}`}
          onClick={() => setPayMethod('transfer')}>
          🏧 {isKo ? '실시간 계좌이체' : 'Real-time Transfer'} <span>{isKo ? '즉시' : 'instant'}</span>
        </button>
        {showWire && (
          <button type="button"
            className={`mmpage-paymethod-opt ${payMethod === 'wire' ? 'is-active' : ''}`}
            onClick={() => setPayMethod('wire')}>
            🏦 {isKo ? '무통장 입금' : 'Manual Deposit'} <span>{isKo ? '관리자 확인 후' : 'admin confirms'}</span>
          </button>
        )}
      </div>
    </div>
  );
}
